<template>
  <div class="compound-extracts-toolbar pa-2">
    <div class="compound-extracts-toolbar__toggle">
      <span class="compound-extracts-toolbar__toggle-label mr-2">{{ tkey('filterLabel') }}:</span>
      <BaseToggle
        class="mr-1"
        mandatory
        :value="selectedExtractFilter"
        :left-toggle="toggle.leftToggle"
        :right-toggle="toggle.rightToggle"
        @input="$emit('update-selected-extract-filter', $event)"
      />
      <DocsLink :link="`toolguide/140-extracts.html`" />
    </div>
    <div style="max-width: 240px">
      <RtlsSearch
        v-model="searchString"
        :placeholder="tkey('searchPlaceholder')"
        class="mr-3"
        @update:model-value="$emit('update-extract-name-filter', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import compoundExtractFilters from '@enums/compound-extract-filters';
import { useContextStore } from '@/stores/context';
import { useCompoundExtractStore } from '@/stores/compound-extract';
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  emits: ['update-selected-extract-filter', 'update-extract-name-filter'],

  setup() {
    const { tkey } = useInternationalization('compoundExtractsPage.toolbar');
    return { tkey };
  },

  data() {
    return {
      toggle: {
        leftToggle: {
          value: compoundExtractFilters.all,
          translation: '',
        },
        rightToggle: {
          value: null,
          translation: null,
        },
      },
      searchString: '',
    };
  },

  computed: {
    ...mapState(useCompoundExtractStore, ['selectedExtractFilter']),
    ...mapState(useContextStore, ['getFullName']),
  },

  created() {
    // Set the value of the right toggle to the full name of the user
    this.toggle.rightToggle.value = this.getFullName;
  },
  mounted() {
    this.toggle.leftToggle.translation = this.tkey('toggle.allBtn');
    this.toggle.rightToggle.translation = this.tkey('toggle.myExtractsBtn');
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.compound-extracts-toolbar {
  border-bottom: 1px solid #eff5f6;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__toggle {
    align-items: center;
    display: flex;
    :deep(.v-btn) {
      height: 29px !important;
      min-width: 0 !important;

      span {
        font-size: 1.4rem;
      }
    }

    :deep(.v-btn-group--density-default.v-btn-group) {
      height: 29px !important;
    }

    :deep(.v-btn--size-default) {
      padding: 0 17px !important;
    }
  }

  &__toggle-label {
    color: $assortment-font-colour;
    font-size: 1.4rem;
  }
}

:deep(.generate-extracts__button) {
  height: 32px !important;
  padding: 0 12px !important;

  span {
    font-size: 1.6rem;
  }
}

:deep(.generate-extracts__icon) {
  margin-left: 2px;
}

.extract-link {
  color: inherit;
  text-decoration: none;
}
</style>
